import { Directive, Input, Renderer2, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[appLeftbarContent]',
    standalone: false
})
export class LeftbarContentDirective implements OnChanges, OnDestroy {
  @Input() isLeftbarOpen: boolean = false;
  @Input() shouldShowSettingsMenu: boolean = false;
  private routerSubscription: Subscription;

  constructor(private renderer: Renderer2, private router: Router) {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this.updateLeftbar();
        }, 0);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('isLeftbarOpen' in changes || 'shouldShowSettingsMenu' in changes) {
      setTimeout(() => {
        this.updateLeftbar();
      }, 0);
    }
  }

  private updateLeftbar(): void {
    const leftBarTabsContent = document.querySelector('.leftbar__tabs-content') as HTMLElement;

    if (!leftBarTabsContent || !this.shouldShowSettingsMenu) {
      return;
    }

    const buttons = Array.from(leftBarTabsContent.querySelectorAll('button'));
    const lastFourButtons = buttons.slice(-4);
    const otherButtons = buttons.slice(0, -4);

    otherButtons.forEach(button => {
      this.renderer.removeStyle(button, 'display');
      const svgIcon = button.querySelector('evc-svg-icon');
      if (!svgIcon) {
        const newIcon = this.renderer.createElement('evc-svg-icon');
        this.renderer.appendChild(button, newIcon);
      }
    });

    if (!this.isLeftbarOpen) {
      lastFourButtons.forEach(button => {
        this.renderer.setStyle(button, 'display', 'none');
      });
      return;
    }

    lastFourButtons.forEach(button => {
      this.renderer.removeStyle(button, 'display');
      const svgIcon = button.querySelector('evc-svg-icon');
      if (svgIcon) {
        svgIcon.remove();
      }
    });

    if (!leftBarTabsContent.querySelector('#divider')) {
      const divider = this.renderer.createElement('div');
      this.renderer.setAttribute(divider, 'id', 'divider');

      if (lastFourButtons.length > 0) {
        leftBarTabsContent.insertBefore(divider, lastFourButtons[0]);
      }
    }
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
